import _without from "lodash/without";
import _isArray from "lodash/isArray";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { StyleSheet } from 'react-native';
import AbstractField from './AbstractField';
const styles = StyleSheet.create({
  padding: {
    paddingLeft: 10
  },
  margin: {
    marginBottom: 10
  }
});

class AbstractEnumerableField extends AbstractField {
  getWidget() {
    const {
      schema,
      widgets,
      uiSchema
    } = this.props;
    let Widget;
    const widgetName = uiSchema['ui:widget'];

    if (widgetName === 'radioboxes' || widgetName === 'checkboxes') {
      let values = uiSchema['ui:enum'] || schema.enum || [];

      if (_isArray(uiSchema['ui:enumExcludes'])) {
        values = _without(values, uiSchema['ui:enumExcludes']);
      }

      const labels = uiSchema['ui:enumNames'] || schema.enumNames || values;
      const {
        RadioWidget,
        CheckboxWidget
      } = widgets;
      const BaseWidget = widgetName === 'radioboxes' ? RadioWidget : CheckboxWidget;
      const inlineOptions = uiSchema['ui:options'] && uiSchema['ui:options'].inline;

      Widget = ({
        value,
        style,
        ...props
      }) =>
      /*#__PURE__*/
      // eslint-disable-line
      React.createElement(React.Fragment, null, values.map((trueValue, i) => /*#__PURE__*/React.createElement(BaseWidget, _extends({}, props, {
        auto: uiSchema['ui:inline'] || inlineOptions,
        key: trueValue,
        text: labels[i],
        checked: value === trueValue,
        style: [uiSchema['ui:inline'] && uiSchema['ui:title'] !== false || i > 0 && (uiSchema['ui:inline'] || inlineOptions) ? styles.padding : null, !uiSchema['ui:inline'] ? styles.margin : null, style],
        value: trueValue
      }))));
    }

    return Widget;
  }

}

export default AbstractEnumerableField;